import { View } from "react-native";
import { Text } from "react-native-ui-lib";
import { VStack, HStack, Button } from "@towersystems/roam-common-native";
import {
  DragDropActionTypes,
  useDragDropContext,
} from "../../../../../../utilities/drag-drop";
import { useLayoutProvider } from "../../../../utils/layout";

export function QuickListEmptyLayout() {
  const { isEditing, layout, layoutNodes, startEditing } = useLayoutProvider();
  const { performLayoutAction } = useDragDropContext();

  function handleApplyDefaultLayoutConfiguration() {
    if (!layout) throw Error("Layout is undefined.");

    performLayoutAction({
      type: DragDropActionTypes.APPLY_DEFAULT_LAYOUT_CONFIGURATION,
      payload: {
        id: layout.id,
      },
    });
  }

  const showSetupButton = layoutNodes.length === 0 && !isEditing;

  const emptyLayoutMarkup = showSetupButton ? (
    <VStack>
      <View
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Text text70>
          Looks like your custom layout contains no tiles, choose from the
          actions below
        </Text>
      </View>
      <HStack>
        <Button
          isAction
          style={{ flexGrow: 1 }}
          label="Edit Layout"
          onPress={startEditing}
        />
        <Button
          isAction
          style={{ flexGrow: 1 }}
          label="Reset to Default"
          onPress={handleApplyDefaultLayoutConfiguration}
        />
      </HStack>
    </VStack>
  ) : null;

  return emptyLayoutMarkup;
}
